/* ============================================================
   DYNASTY DRINKS — THEME JAVASCRIPT
   ============================================================ */

document.addEventListener('DOMContentLoaded', () => {
  initNav();
  initCart();
  initGallery();
  initVariants();
  initQuantity();
  initAccordions();
  initStickyATC();
  initScrollAnimations();
  initSortSelect();
});

/* ============================================================
   NAV — mobile toggle
   ============================================================ */
function initNav() {
  const toggle   = document.getElementById('nav-toggle');
  const nav      = document.getElementById('mobile-nav');
  const closeBtn = document.getElementById('nav-close');
  if (!toggle || !nav) return;

  let savedScroll = 0;

  function openNav() {
    savedScroll = window.scrollY;
    nav.classList.add('is-open');
    nav.setAttribute('aria-hidden', 'false');
    toggle.setAttribute('aria-expanded', 'true');
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + savedScroll + 'px';
    document.body.style.width = '100%';
  }

  function closeNav() {
    nav.classList.remove('is-open');
    nav.setAttribute('aria-hidden', 'true');
    toggle.setAttribute('aria-expanded', 'false');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, savedScroll);
  }

  toggle.addEventListener('click', () => {
    nav.classList.contains('is-open') ? closeNav() : openNav();
  });

  closeBtn?.addEventListener('click', closeNav);

  nav.querySelectorAll('.mobile-nav__link').forEach(link => {
    link.addEventListener('click', closeNav);
  });
}

/* ============================================================
   CART DRAWER
   ============================================================ */
function initCart() {
  const trigger  = document.getElementById('cart-trigger');
  const drawer   = document.getElementById('cart-drawer');
  const overlay  = document.getElementById('cart-overlay');
  const closeBtn = document.getElementById('cart-close');
  if (!drawer) return;

  function openCart() {
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    trigger?.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    closeBtn?.focus();
  }

  function closeCart() {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    trigger?.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    trigger?.focus();
  }

  window.closeCart = closeCart;

  trigger?.addEventListener('click', openCart);
  closeBtn?.addEventListener('click', closeCart);
  overlay?.addEventListener('click', closeCart);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeCart();
  });

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;

    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    btn.disabled = true;
    const originalText = btn.textContent;
    btn.textContent = '…';

    try {
      await addToCart(variantId, 1);
      const cart = await fetch('/cart.js').then(r => r.json());
      refreshCartUI(cart);
      openCart();
    } catch (err) {
      console.error('Add to cart failed:', err);
    } finally {
      btn.disabled = false;
      btn.textContent = originalText;
    }
  });

  const drawerBody = document.getElementById('cart-drawer-body');
  drawerBody?.addEventListener('click', async (e) => {
    const btn = e.target.closest('.cart-qty__btn');
    if (!btn) return;

    const key    = btn.dataset.key;
    const action = btn.dataset.action;
    const item   = btn.closest('.cart-item');
    const qtyEl  = item?.querySelector('.cart-qty__num');
    if (!key || !qtyEl) return;

    let qty = parseInt(qtyEl.textContent, 10);
    qty = action === 'increase' ? qty + 1 : Math.max(0, qty - 1);

    try {
      const data = await updateCartItem(key, qty);
      refreshCartUI(data);
    } catch (err) {
      console.error('Cart update failed:', err);
    }
  });
}

async function addToCart(variantId, quantity = 1) {
  const res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity }),
  });
  if (!res.ok) throw new Error(await res.text());
  const data = await res.json();
  await refreshCartCount();
  return data;
}

async function updateCartItem(key, quantity) {
  const res = await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: key, quantity }),
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

async function refreshCartCount() {
  const res  = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
  const cart = await res.json();
  const countEl = document.getElementById('cart-count');
  if (countEl) countEl.textContent = cart.item_count;
  return cart;
}

window.refreshCartUI = refreshCartUI;
function refreshCartUI(cart) {
  const countEl    = document.getElementById('cart-count');
  const subtotalEl = document.getElementById('cart-subtotal');
  if (countEl) countEl.textContent = cart.item_count;
  if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

  const footer = document.querySelector('.cart-drawer__footer');
  if (footer) footer.style.display = cart.item_count === 0 ? 'none' : '';

  const drawerBody = document.getElementById('cart-drawer-body');
  if (!drawerBody) return;

  if (cart.item_count === 0) {
    drawerBody.innerHTML = `
      <div style="height:200px;display:flex;align-items:center;justify-content:center;flex-direction:column;gap:1rem;text-align:center;">
        <p style="color:var(--color-text-muted)">Your cart is empty</p>
        <a href="/products/ceremonial-grade-organic-matcha-50g-50-servings" class="btn btn--outline" onclick="closeCart()">Continue Shopping</a>
      </div>`;
    return;
  }

  const items = cart.items.map(item => `
    <div class="cart-item" data-key="${item.key}">
      <img class="cart-item__image"
           src="${resizeImage(item.image, 160)}"
           alt="${escapeHtml(item.title)}"
           width="80" height="80" loading="lazy">
      <div>
        <p class="cart-item__title">${escapeHtml(item.product_title)}</p>
        ${item.variant_title && item.variant_title !== 'Default Title'
          ? `<p class="cart-item__variant">${escapeHtml(item.variant_title)}</p>` : ''}
        <div class="cart-qty">
          <button class="cart-qty__btn" data-action="decrease" data-key="${item.key}" aria-label="Decrease quantity">−</button>
          <span class="cart-qty__num">${item.quantity}</span>
          <button class="cart-qty__btn" data-action="increase" data-key="${item.key}" aria-label="Increase quantity">+</button>
        </div>
      </div>
      <span class="cart-item__price">${formatMoney(item.final_line_price)}</span>
    </div>`).join('');

  drawerBody.innerHTML = items;
}

function formatMoney(cents) {
  return '£' + (cents / 100).toFixed(2);
}

function resizeImage(url, size) {
  if (!url) return '';
  return url.replace(/(\.[^.]+)$/, `_${size}x$1`);
}

function escapeHtml(str) {
  if (!str) return '';
  return str.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
}

/* ============================================================
   PRODUCT FORM — AJAX submit
   ============================================================ */
document.addEventListener('submit', async (e) => {
  const form = e.target.closest('.product-form');
  if (!form) return;

  e.preventDefault();

  const btn      = form.querySelector('#add-to-cart-btn');
  const varInput = form.querySelector('#variant-id-input');
  const qtyInput = form.querySelector('#quantity-input');
  if (!varInput) return;

  const variantId = varInput.value;
  const quantity  = parseInt(qtyInput?.value || '1', 10);

  if (btn) {
    btn.disabled = true;
    btn.textContent = '…';
  }

  try {
    await addToCart(variantId, quantity);
    if (btn) {
      btn.textContent = '✓ Added!';
      btn.style.backgroundColor = '#2ecc71';
      setTimeout(() => {
        btn.disabled = false;
        btn.textContent = 'Add to Cart';
        btn.style.backgroundColor = '';
      }, 1600);
    }

    const drawer = document.getElementById('cart-drawer');
    const overlay = document.getElementById('cart-overlay');
    if (drawer) {
      drawer.classList.add('is-open');
      overlay?.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    await refreshCartCount();
    const cart = await fetch('/cart.js').then(r => r.json());
    refreshCartUI(cart);

  } catch (err) {
    console.error(err);
    if (btn) {
      btn.disabled = false;
      btn.textContent = 'Add to Cart';
    }
  }
});

/* ============================================================
   PRODUCT GALLERY — thumbnail switcher
   ============================================================ */
function initGallery() {
  const gallery = document.getElementById('gallery-main');
  if (!gallery) return;

  const slides = gallery.querySelectorAll('.pdp__gallery-slide');
  const thumbs = document.querySelectorAll('.pdp__gallery-thumb');

  function goTo(index) {
    slides.forEach((s, i) => s.classList.toggle('is-active', i === index));
    thumbs.forEach((t, i) => {
      t.classList.toggle('is-active', i === index);
      t.setAttribute('aria-current', i === index ? 'true' : 'false');
    });
  }

  thumbs.forEach((thumb, i) => {
    thumb.addEventListener('click', () => goTo(i));
  });

  const prevBtn = document.getElementById('gallery-prev');
  const nextBtn = document.getElementById('gallery-next');
  prevBtn?.addEventListener('click', () => {
    const current = [...slides].indexOf(gallery.querySelector('.pdp__gallery-slide.is-active'));
    if (current > 0) goTo(current - 1);
  });
  nextBtn?.addEventListener('click', () => {
    const current = [...slides].indexOf(gallery.querySelector('.pdp__gallery-slide.is-active'));
    if (current < slides.length - 1) goTo(current + 1);
  });

  let touchStartX = 0;
  gallery.addEventListener('touchstart', (e) => { touchStartX = e.touches[0].clientX; }, { passive: true });
  gallery.addEventListener('touchend', (e) => {
    const dx = e.changedTouches[0].clientX - touchStartX;
    if (Math.abs(dx) < 40) return;
    const active = gallery.querySelector('.pdp__gallery-slide.is-active');
    const current = [...slides].indexOf(active);
    if (dx < 0 && current < slides.length - 1) goTo(current + 1);
    else if (dx > 0 && current > 0) goTo(current - 1);
  });
}

/* ============================================================
   PRODUCT VARIANTS — option selector → URL + price update
   ============================================================ */
function initVariants() {
  const form = document.querySelector('.product-form');
  if (!form) return;

  const swatchInputs = form.querySelectorAll('.product-form__swatch-input');
  if (!swatchInputs.length) return;

  const productData = getProductJson();
  if (!productData) return;

  swatchInputs.forEach(input => {
    input.addEventListener('change', () => {
      updateSelectedSwatchUI(form);
      const selectedVariant = findVariant(form, productData);
      if (selectedVariant) applyVariant(selectedVariant);
    });
  });
}

function getProductJson() {
  const el = document.getElementById('product-json');
  if (!el) return null;
  try { return JSON.parse(el.textContent); } catch { return null; }
}

function findVariant(form, productData) {
  const selected = [];
  form.querySelectorAll('.product-form__option').forEach(option => {
    const checked = option.querySelector('.product-form__swatch-input:checked');
    if (checked) selected.push(checked.value);
  });

  return productData.variants.find(v =>
    v.options.every((opt, i) => opt === selected[i])
  ) || null;
}

function updateSelectedSwatchUI(form) {
  form.querySelectorAll('.product-form__option').forEach(option => {
    option.querySelectorAll('.product-form__swatch-label').forEach(label => {
      const input = label.querySelector('.product-form__swatch-input');
      label.classList.toggle('is-selected', input?.checked || false);
    });
  });
}

function applyVariant(variant) {
  const varInput    = document.getElementById('variant-id-input');
  const priceEl     = document.querySelector('.product-buybox__price-current');
  const compareEl   = document.querySelector('.product-buybox__price-compare');
  const atcBtn      = document.getElementById('add-to-cart-btn');
  const stickyBtn   = document.getElementById('sticky-atc-btn');
  const stickyPrice = document.getElementById('sticky-price');

  if (varInput) varInput.value = variant.id;
  if (stickyBtn) stickyBtn.dataset.variantId = variant.id;

  if (priceEl) priceEl.textContent = formatMoney(variant.price);
  if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);

  if (compareEl) {
    if (variant.compare_at_price > variant.price) {
      compareEl.textContent = formatMoney(variant.compare_at_price);
      compareEl.style.display = '';
    } else {
      compareEl.style.display = 'none';
    }
  }

  if (atcBtn) {
    atcBtn.disabled = !variant.available;
    atcBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
  }

  if (variant.featured_image) {
    const gallery = document.getElementById('gallery-main');
    const slides  = gallery?.querySelectorAll('.pdp__gallery-slide');
    slides?.forEach((slide, i) => {
      const img = slide.querySelector('img');
      if (img && img.src.includes(variant.featured_image.src?.split('/').pop()?.split('?')[0])) {
        document.querySelectorAll('.pdp__gallery-thumb')[i]?.click();
      }
    });
  }

  const url = new URL(window.location.href);
  url.searchParams.set('variant', variant.id);
  window.history.replaceState({}, '', url.toString());
}

/* ============================================================
   QUANTITY SELECTOR
   ============================================================ */
function initQuantity() {
  const decrease = document.getElementById('qty-decrease');
  const increase = document.getElementById('qty-increase');
  const input    = document.getElementById('quantity-input');
  if (!input) return;

  decrease?.addEventListener('click', () => {
    const val = parseInt(input.value, 10);
    if (val > 1) input.value = val - 1;
  });

  increase?.addEventListener('click', () => {
    input.value = parseInt(input.value, 10) + 1;
  });

  input.addEventListener('change', () => {
    if (parseInt(input.value, 10) < 1) input.value = 1;
  });
}

/* ============================================================
   ACCORDIONS
   ============================================================ */
function initAccordions() {
  document.querySelectorAll('.accordion__trigger').forEach(trigger => {
    const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
    const item = trigger.closest('.accordion__item');
    if (isExpanded && item) item.classList.add('is-open');

    trigger.addEventListener('click', () => {
      const item    = trigger.closest('.accordion__item');
      const isOpen  = item.classList.contains('is-open');
      const bodyId  = trigger.getAttribute('aria-controls');
      const body    = document.getElementById(bodyId);

      item.classList.toggle('is-open', !isOpen);
      trigger.setAttribute('aria-expanded', !isOpen);
      if (body) body.setAttribute('aria-hidden', isOpen);
    });
  });
}

/* ============================================================
   STICKY ATC
   ============================================================ */
function initStickyATC() {
  const stickyBar = document.getElementById('sticky-atc');
  const mainBtn   = document.getElementById('add-to-cart-btn');
  const stickyBtn = document.getElementById('sticky-atc-btn');
  if (!stickyBar || !mainBtn) return;

  const observer = new IntersectionObserver(
    ([entry]) => {
      const show = !entry.isIntersecting;
      stickyBar.classList.toggle('is-visible', show);
      stickyBar.setAttribute('aria-hidden', !show);
    },
    { rootMargin: '-80px 0px 0px 0px', threshold: 0 }
  );

  observer.observe(mainBtn);

  stickyBtn?.addEventListener('click', async () => {
    const variantId = stickyBtn.dataset.variantId;
    if (!variantId) return;
    stickyBtn.disabled = true;
    const orig = stickyBtn.textContent;
    stickyBtn.textContent = '…';
    try {
      await addToCart(variantId, 1);
      const drawer  = document.getElementById('cart-drawer');
      const overlay = document.getElementById('cart-overlay');
      drawer?.classList.add('is-open');
      overlay?.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      const cart = await fetch('/cart.js').then(r => r.json());
      refreshCartUI(cart);
    } finally {
      stickyBtn.disabled = false;
      stickyBtn.textContent = orig;
    }
  });
}

/* ============================================================
   SCROLL ANIMATIONS — Intersection Observer
   ============================================================ */
function initScrollAnimations() {
  const elements = document.querySelectorAll('[data-animate]');
  if (!elements.length) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    elements.forEach(el => el.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -60px 0px', threshold: 0.1 }
  );

  elements.forEach(el => observer.observe(el));
}

/* ============================================================
   COLLECTION SORT
   ============================================================ */
function initSortSelect() {
  const select = document.querySelector('[data-sort]');
  if (!select) return;

  select.addEventListener('change', () => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', select.value);
    window.location.href = url.toString();
  });
}
